import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';

const ConfirmAccount = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [eroare, setEroare] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      // Așteptăm sesiunea (Supabase o procesează în background)
      const check = async () => {
        const { data: { session }, error } = await supabase.auth.getSession();
        if (session && !error) {
          setLoading(false);
          return true;
        }
        return false;
      };

      // Retry x3 pentru race condition
      let attempts = 0;
      const maxAttempts = 3;
      
      const tryCheck = async () => {
        while (attempts < maxAttempts) {
          attempts++;
          if (await check()) return;
          await new Promise(r => setTimeout(r, 500));
        }
        setEroare('Link invalid sau expirat. Încearcă din nou.');
        setLoading(false);
      };

      tryCheck();
    };

    checkSession();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEroare('');
    setStatus('');

    const { error } = await supabase.auth.updateUser({ 
      password 
    });

    if (error) {
      setEroare(error.message);
    } else {
      setStatus('✅ Parola a fost setată cu succes! Redirecționare...');
      setTimeout(() => {
        navigate('/');
      }, 1500);
    }
  };

  if (loading) {
    return (
      <div className="login-wrapper">
        <div className="login-card" style={{ textAlign: 'center', padding: '60px 40px' }}>
          <img src={logo} alt="Logo" className="login-logo" />
          <h3 className="text-center mb-4 fw-bold">🔄 Se verifică linkul...</h3>
          <p>Vă rugăm așteptați câteva momente.</p>
        </div>
      </div>
    );
  }

  if (eroare && eroare.includes('invalid')) {
    return (
      <div className="login-wrapper">
        <div className="login-card" style={{ textAlign: 'center', padding: '60px 40px' }}>
          <img src={logo} alt="Logo" className="login-logo" />
          <h3 className="text-center mb-4 fw-bold text-danger">⚠️ Link invalid</h3>
          <p>{eroare}</p>
          <button 
            className="btn btn-primary w-100 mt-2" 
            onClick={() => navigate('/')}
          >
            Înapoi la autentificare
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <img src={logo} alt="Logo" className="login-logo" />
        <h3 className="text-center mb-4 fw-bold">🔐 Setează parolă nouă</h3>
        <p className="text-center text-muted mb-4" style={{ fontSize: '14px' }}>
          Ai primit un link de resetare. Introdu noua parolă.
        </p>
        
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div className="mb-3">
            <label>Parolă nouă</label>
            <input
              className="neomorphic-input"
              type="password"
              placeholder="Parola ta nouă (min. 6 caractere)"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={6}
              required
            />
          </div>
          
          {eroare && <p className="text-danger">{eroare}</p>}
          {status && <p className={status.includes('succes') ? 'text-success' : 'text-danger'}>{status}</p>}
          
          <button type="submit" className="btn btn-primary w-100 mt-2">
            Confirmă parolă nouă
          </button>
        </form>
        
        <p className="text-center mt-3 mb-0">
          <small>
            <a href="/" className="text-decoration-none" style={{ color: '#0033a1' }}>
              ← Înapoi la autentificare
            </a>
          </small>
        </p>
      </div>
    </div>
  );
};

export default ConfirmAccount;
